import React, { Component } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import {
  cartGrossWeight,
  shippingCostForWeight,
  formatWeight,
} from "./shipping";
class Recipe extends Component {

  constructor (props) {
    super(props);
    this.state = { name: '',
                   email: '',
                   adresse: '',
                   ort: '',
                   plz: '',
                   telefon: '',
                   kommentar: '',
                   versand: '',
                   bezahlung: '',
                   error: ''  };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange (event) {
    // Fehlermeldung verschwindet, sobald der Kunde etwas korrigiert.
    this.setState({[event.target.name]: event.target.value, error: '' });
  }

  checkoutClick () {
    const { t } = this.props;
    if(this.props.addedItems.length === 0){
      this.setState({ error: t("warenkorb.Error empty") });
    }
    else if(this.state.name.trim() === '' || this.state.email.trim() === ''){
      this.setState({ error: t("warenkorb.Error contact") });
    }
    else if(this.state.versand === ''){
      this.setState({ error: t("warenkorb.Error shipping") });
    }
    else if(this.state.bezahlung === ''){
      this.setState({ error: t("warenkorb.Error payment") });
    }
    else{
      this.setState({ error: '' });
      // Der folgende Text geht in die Bestellmail und bleibt bewusst
      // deutsch: Die EmailJS-Vorlage ist deutsch, ein gemischtsprachiges
      // Mail waere schlechter als ein durchgehend deutsches.
      var text = '';
      // eslint-disable-next-line array-callback-return
      this.props.addedItems.map( item => {
      text = text +'<p>'+item.quantity+ ' x  '+ item.subtitle+' '+ item.price+' CHF</p>'})
      const grams = cartGrossWeight(this.props.addedItems);
      const shipping = this.state.versand === 'postversand' ? shippingCostForWeight(grams) : 0;
      const grandTotal = this.props.total + shipping;
      text = text +'<p>Zwischensumme '+ this.props.total.toFixed(2) +' CHF</p>'
      const versandLabel = this.state.versand === 'persoenlich'
        ? 'Persönliche Übergabe (gemäss vorheriger individueller Absprache)'
        : 'Postversand · Paketgewicht ca. ' + formatWeight(grams) + ' · ' + shipping.toFixed(2) + ' CHF';
      text = text + '<p><b>Versand:</b> ' + versandLabel + '</p>'
      text = text +'<p><b>Preis Total '+ grandTotal.toFixed(2) +' CHF</b></p>'
      text = text + '<p><b>Zahlungsart:</b> ' + this.state.bezahlung + '</p>'
      this.handleSubmit(text);
    }
  }

  handleSubmit (text) {
    const templateId = 'template_3ZtHnJx8';
    this.sendFeedback(templateId, {
      order: text,
      kommentar: this.state.kommentar,
      name: this.state.name,
      email: this.state.email,
      adresse: this.state.adresse,
      ort: this.state.ort,
      plz: this.state.plz,
      telefon: this.state.telefon,
      } )
  }

  sendFeedback (templateId, variables) {
    window.emailjs.send(
      'gmail', templateId,
      variables
      ).then(res => {
        console.log('Email successfully sent!')
        this.props.onOrderComplete(this.state.bezahlung);
      })
      //Handle errors here however you like, or use a React error boundary
      .catch(err => console.error('Oh well, you failed. Here some thoughts on the error that occured:', err))
  }

  render() {
    const { t } = this.props;
    const grams = cartGrossWeight(this.props.addedItems);
    const postageCost = shippingCostForWeight(grams);
    const shipping = this.state.versand === 'postversand' ? postageCost : 0;
    const grandTotal = this.props.total + shipping;
    return (
      <div className="container-form">
        <div className="cart-rd-group">
          <div className="cart-rd-group-head">{t("warenkorb.Shipping heading")}</div>
          <p className="cart-rd-versand-intro">{t("warenkorb.Shipping intro")}</p>
          <label className="cart-rd-radio-row">
            <input
              type="radio"
              name="versand"
              value="persoenlich"
              checked={this.state.versand === 'persoenlich'}
              onChange={this.handleChange}
            />
            <span className="cart-rd-radio-label">{t("warenkorb.Shipping pickup")}</span>
            <span className="cart-rd-radio-price">0.00 CHF</span>
          </label>
          <label className="cart-rd-radio-row">
            <input
              type="radio"
              name="versand"
              value="postversand"
              checked={this.state.versand === 'postversand'}
              onChange={this.handleChange}
            />
            <span className="cart-rd-radio-label">
              {t("warenkorb.Shipping post")}
              {grams > 0 && (
                <span className="cart-rd-radio-note">
                  {t("warenkorb.Shipping note", { weight: formatWeight(grams) })}
                </span>
              )}
            </span>
            <span className="cart-rd-radio-price">{postageCost.toFixed(2)} CHF</span>
          </label>
        </div>

        <div className="cart-rd-total">
          {shipping > 0 && (
            <p className="cart-rd-total-line">
              <span>{t("warenkorb.Subtotal")}</span>
              <span>{this.props.total.toFixed(2)} CHF</span>
            </p>
          )}
          {shipping > 0 && (
            <p className="cart-rd-total-line">
              <span>{t("warenkorb.Shipping")}</span>
              <span>{shipping.toFixed(2)} CHF</span>
            </p>
          )}
          <h3>{t("warenkorb.Total")}: {(Math.round(grandTotal * 100) / 100).toFixed(2)} CHF</h3>
        </div>

        <div className="cart-rd-group">
          <div className="cart-rd-group-head">{t("warenkorb.Contact heading")}</div>
          <form className="order-form" onSubmit={e => e.preventDefault()}>
            <div className="order-field">
              <label htmlFor="of-name">{t("warenkorb.Field name")} <abbr title={t("warenkorb.Required")}>*</abbr></label>
              <input id="of-name" name="name" type="text" autoComplete="name"
                value={this.state.name} onChange={this.handleChange} />
            </div>
            <div className="order-field">
              <label htmlFor="of-email">{t("warenkorb.Field email")} <abbr title={t("warenkorb.Required")}>*</abbr></label>
              <input id="of-email" name="email" type="email" autoComplete="email"
                value={this.state.email} onChange={this.handleChange} />
            </div>
            <div className="order-field">
              <label htmlFor="of-adresse">{t("warenkorb.Field street")}</label>
              <input id="of-adresse" name="adresse" type="text" autoComplete="street-address"
                value={this.state.adresse} onChange={this.handleChange} />
            </div>
            <div className="order-row">
              <div className="order-field order-field-plz">
                <label htmlFor="of-plz">{t("warenkorb.Field zip")}</label>
                <input id="of-plz" name="plz" type="text" inputMode="numeric" autoComplete="postal-code"
                  value={this.state.plz} onChange={this.handleChange} />
              </div>
              <div className="order-field">
                <label htmlFor="of-ort">{t("warenkorb.Field city")}</label>
                <input id="of-ort" name="ort" type="text" autoComplete="address-level2"
                  value={this.state.ort} onChange={this.handleChange} />
              </div>
            </div>
            <div className="order-field">
              <label htmlFor="of-telefon">{t("warenkorb.Field phone")}</label>
              <input id="of-telefon" name="telefon" type="tel" autoComplete="tel"
                value={this.state.telefon} onChange={this.handleChange} />
            </div>
            <div className="order-field">
              <label htmlFor="of-bezahlung">{t("warenkorb.Field payment")} <abbr title={t("warenkorb.Required")}>*</abbr></label>
              <select id="of-bezahlung" name="bezahlung"
                className={this.state.bezahlung === '' ? 'is-placeholder' : ''}
                value={this.state.bezahlung} onChange={this.handleChange}>
                <option value="" disabled>{t("warenkorb.Payment placeholder")}</option>
                <option value="TWINT">TWINT</option>
                <option value="Banküberweisung">{t("warenkorb.Payment transfer")}</option>
              </select>
            </div>
            <div className="order-field">
              <label htmlFor="of-kommentar">
                {t("warenkorb.Field comment")} <span className="order-optional">{t("warenkorb.Optional")}</span>
              </label>
              <textarea id="of-kommentar" name="kommentar" rows="3"
                placeholder={t("warenkorb.Comment placeholder")}
                value={this.state.kommentar} onChange={this.handleChange} />
            </div>
          </form>
          <p className="order-required-note">
            <abbr title={t("warenkorb.Required")}>*</abbr> {t("warenkorb.Required")}
          </p>
        </div>

        {this.state.error && (
          <p className="order-error" role="alert">{this.state.error}</p>
        )}

        <div className="checkout">
          <button type="button" className="checkout-btn" onClick={this.checkoutClick.bind(this)}>
            {t("warenkorb.Submit")}
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    addedItems: state.addedItems,
    total: state.total
  };
};

export default connect(
  mapStateToProps
)(withTranslation()(Recipe));
